import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const name = "selectedFunding";
const initialState = {
  selectedFunding: [],
  loading: false,
  error: null,
};

export const selectFunding = createAsyncThunk(
  "funding/selectFunding",
  async (funding) => {
    return funding;
  }
);

const selectedFundingSlice = createSlice({
  name,
  initialState,
  extraReducers: (builder) => {
    builder.addCase(selectFunding.pending, (state) => {
      state.selectedFunding = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(selectFunding.fulfilled, (state, action) => {
      state.selectedFunding = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(selectFunding.rejected, (state, action) => {
      state.selectedFunding = [];
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default selectedFundingSlice.reducer;
